var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73479 7.28098H11.2652C11.4611 7.28098 11.5705 7.04643 11.4491 6.8863L8.18394 2.59219C8.09048 2.46927 7.91052 2.46927 7.81606 2.59219L4.55085 6.8863C4.42955 7.04643 4.53892 7.28098 4.73479 7.28098Z",
    fill: "#AFB7FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSortAsc);
export default __webpack_public_path__ + "static/media/arrow-sort-asc.8afbf69a7caec5c5505269f349c76b9a.svg";
export { ForwardRef as ReactComponent };